import z from "zod"

export const OutlookIntegrationGenerateAuthUrlResponseDataSchema = z.object({
  url: z.string(),
})

export const OutlookIntegrationGetTokenResponseDataSchema = z.object({
  success: z.boolean(),
  outlookAccountId: z.bigint().transform(String),
  accountEmail: z.string(),
  mailboxEmail: z.string(),
  isPersonalAccount: z.boolean(),
})

const OutlookIntegration = z.object({
  id: z.bigint().transform(String),
  outlookAccountId: z.bigint().transform(String),
  email: z.string(),
  isShared: z.boolean(),
  outlookAccount: z.object({ email: z.string() }),
  createdAt: z.date().transform((value) => value.toISOString()),
  updatedAt: z.date().transform((value) => value.toISOString()),
})

export const OutlookIntegrationsResponseDataSchema = z.array(OutlookIntegration)

export const OutlookMailboxValidationResponseDataSchema = z.object({
  status: z.enum(["ok", "forbidden", "notFound", "self"]),
})

export const OutlookDiscoveredMailboxesResponseDataSchema = z.object({
  mailboxes: z.array(
    z.object({
      email: z.string(),
      displayName: z.string().nullable(),
    }),
  ),
})
